<template>
  <div
    v-loading="loading"
    class="app-main-content"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(170,170,170,0.5)"
  >
    <div v-show="view==='list'" class="grid-view">
      <div class="main-content">
        <div class="section operations">
          <div class="triggers">
            <search-item
              config-module="2801"
              :reset="true"
              :custom-search-items="customSearchItems"
              :custom-sim-query-placeholder="$t('Message.PleaseEnterTheWarehouseNumber')"
              @click-more="value=>isAdvancedQuery=value"
              @simSearchItemCallBack="toSimpleQuery"
              @advSearchItemCallBack="toAdvancedQuery"
            >
              <div slot="operations">
                <el-button type="primary" @click="inWarehouseHandler">{{ $t('queryJob.warehousing') }}</el-button>
                <el-button :disabled="rowData.length === 0" no="print" type="primary" @click="onPrintHandler()">{{ $t('SeaExport.print') }}</el-button>
                <el-select v-model="timeRange" style="width: 100px;padding-left: 5px" @change="onTimeRangeChange">
                  <el-option
                    v-for="(item,index) in TIME_RANGES"
                    :key="index"
                    :label="$store.getters.language==='zh'?item.chineseName:item.chineseName"
                    :value="item.code"
                  />
                </el-select>
                <el-date-picker
                  v-model="filter.arriveDateStart"
                  :disabled="timeRange!==CUSTOM.code"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :editable="false"
                  :clearable="false"
                  style="width: 120px;margin:0 5px;"
                />-
                <el-date-picker
                  v-model="filter.arriveDateEnd"
                  :disabled="timeRange!==CUSTOM.code"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :editable="false"
                  :clearable="false"
                  style="width: 120px;margin-left: 5px;"
                />
                <el-checkbox v-model="autoRefresh" style="margin: 0 5px;" @change="resetTimer">{{ $t('SeaExport.AutomaticallyRefresh') }}</el-checkbox>
              </div>
            </search-item>
          </div>
        </div>
        <cargo-ag-grid
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          class="section grid-wrapper"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
    </div>
    <warehousing-workspace
      v-show="view==='detail'"
      ref="warehousingWorkspace"
      :parent-context="context"
      lob="SE"
      @back="backToList"
      @refresh="refreshHandle"
    />

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>

<script>
import tabForm from '@/views/cargo/v0/AirExport/components/stayWarehousing/tabForm'
import LocalStorageUtils from '@/utils/localStorageUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { YESTERDAY, TODAY, TOMORROW, CUSTOM } from '@/class/cargo/model/parameters/RouteConstants'
import { calcTimeRange } from '@/class/cargo/model/parameters/RouteConstants'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch.vue'
import { WarehousingContext } from '@/components/Cargo/FrontEndWarehouse/components/warehousing/warehousingContext'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { IMPERIAL_4 } from '@/class/cargo/model/parameters/SystemConstants'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { complexQuerySeJobs } from '@/api/seaExport/seaExportJob'
import WarehousingWorkspace from '@/components/Cargo/Warehouse/components/warehousing/warehousingWorkspace.vue'

export default {
  name: 'StayWarehousingList',
  components: { WarehousingWorkspace, searchItem, tabForm, cargoTemplateSelectorDialog },
  data() {
    return {
      context: WarehousingContext.getInstance(),
      loading: false,
      view: 'list',
      TIME_RANGES: [YESTERDAY, TODAY, TOMORROW, CUSTOM],
      CUSTOM,
      timeRange: TODAY.code,
      isAdvancedQuery: false, // 是否为高级查询
      customSearchItems: [],
      filter: {
        conditions: [], // 查询条件
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        arriveDateStart: '',
        arriveDateEnd: '',
        warehouseNo: ''
      },
      autoRefresh: LocalStorageUtils.getConfiguration('SEA_STAY_WAREHOUSING_AUTO_REFRESH') || true,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true, // 如果为true，则不能选择单元格
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: { componentParent: this }
      },
      rowData: [],
      selectedNode: null,
      gridApi: null,
      timerId: 0, // 定时器ID
      tabForm: {
        job: new SeaExportJob().fillDefaultValue().getData()
      },
      templateSelectorDialog: {
        visible: false,
        category: '',
        data: {}
      }
    }
  },
  computed: {
    officeId() {
      return this.$store.getters.currentOfficeId
    },
    columnDefs() {
      return [
        {
          children: [
            {
              headerName: this.$t('CargoMsg.Cargo_WarehouseNo'),
              field: 'warehouseNo',
              width: 150
            }, {
              headerName: this.$t('Billing.WayBillNumber'),
              field: 'mbl',
              width: 130,
              cellRenderer: params => {
                return ColumnUtils.mawbNoLabelFun(params.value)
              }
            }, {
              headerName: this.$t('SeaExport.CargosExpectedArrivalDate'),
              field: 'arriveDate',
              width: 170,
              cellRenderer: params => {
                return ColumnUtils.dateTimeLabelFunc(params.value)
              }
            }, {
              headerName: this.$t('CargoMsg.Cargo_SailingDate'),
              field: 'etd',
              cellRenderer: params => {
                return ColumnUtils.dateLabelFunc(params.value)
              },
              width: 110
            }
          ]
        }, {
          headerName: this.$t('CargoMsg.Cargo_Consignation'),
          children: [
            {
              headerName: this.$t('SeaExport.Piece'),
              field: 'quantityContract',
              width: 100,
              cellRenderer: params => {
                const txt = ColumnUtils.formatNumber(params.value, 0, true)
                return '<i>' + txt + '</i>'
              }
            }, {
              headerName: this.$t('queryJob.heavy'),
              field: 'weightContract',
              width: 100,
              cellRenderer: params => {
                const txt = ColumnUtils.formatNumber(params.value, 1, true)
                return '<i>' + txt + '</i>'
              },
              filterParams: {},
              filterValueGetter: (params) => {
                return ColumnUtils.formatNumber(params.value, 1, true)
              }
            }, {
              headerName: this.$t('SeaExport.Volume'),
              field: 'cubageContract',
              width: 100,
              cellRenderer: params => {
                const txt = ColumnUtils.formatNumber(params.value, 3, true)
                return '<i>' + txt + '</i>'
              },
              filterParams: {},
              filterValueGetter: (params) => {
                return ColumnUtils.formatNumber(params.value, 3, true)
              }
            }
          ]
        },
        {
          headerName: this.$t('SeaExport.Actual'),
          children: [
            {
              headerName: this.$t('SeaExport.Piece'),
              field: 'quantityActual',
              width: 100,
              cellRenderer: params => {
                const txt = ColumnUtils.formatNumber(params.value, 0, true)
                return '<i>' + txt + '</i>'
              }
            }, {
              headerName: this.$t('queryJob.heavy'),
              field: 'weightActual',
              width: 100,
              cellRenderer: params => {
                const txt = ColumnUtils.formatNumber(params.value, 1, true)
                return '<i>' + txt + '</i>'
              },
              filterParams: {},
              filterValueGetter: (params) => {
                return ColumnUtils.formatNumber(params.value, 1, true)
              }
            }, {
              headerName: this.$t('SeaExport.Volume'),
              field: 'cubageActual',
              width: 100,
              cellRenderer: params => {
                const txt = ColumnUtils.formatNumber(params.value, 3, true)
                return '<i>' + txt + '</i>'
              },
              filterParams: {},
              filterValueGetter: (params) => {
                return ColumnUtils.formatNumber(params.value, 3, true)
              }
            }
          ]
        }, {
          children: [
            {
              headerName: this.$t('SeaExport.Sales'),
              field: 'sales',
              width: 180,
              cellRenderer: (params) => {
                return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_sales') : ''
              }
            },
            {
              headerName: this.$t('SeaExport.CustomerService'),
              field: 'csr',
              width: 180,
              cellRenderer: (params) => {
                return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_csr') : ''
              }
            },
            {
              headerName: this.$t('SeaExport.ConsignationCompany'),
              field: 'customerId',
              width: 180,
              cellRenderer: (params) => {
                return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0') : ''
              }
            }
          ]
        }
      ]
    }
  },
  watch: {
    officeId: {
      async handler(newVal) {
        if (this.office.officeId !== this.officeId) {
          await this.context.prepareData()
        }
      }
    }
  },
  async created() {
    this.onTimeRangeChange()
    await this.init()
    await this.queryJobs()
    await this.context.prepareData()
  },
  methods: {
    onTimeRangeChange() {
      const dateArray = calcTimeRange(this.timeRange)
      if (dateArray) {
        this.filter.arriveDateStart = dateArray[0]
        this.filter.arriveDateEnd = dateArray[1]
      }
    },
    // 高级查询
    toAdvancedQuery(data) {
      this.filter.warehouseNo = ''
      this.filter.conditions = []
      if (typeof data !== 'undefined') {
        this.filter.snapshotConditions = [... data] // 高级查询条件（点击查询时的快照状态）
        this.filter.conditions = [... data]
      }
      this.queryJobs()
    },
    // 简单查询
    toSimpleQuery(keyword) {
      if (typeof keyword !== 'undefined') {
        this.filter.warehouseNo = keyword.trim()
      }
      this.queryJobs()
    },
    async init() {
    },
    async queryJobs(operator = '') {
      let conditions = [
        new AdvancedSearchOption(null, 'job.JOB_STATE', [0, 1, 2], AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json(),
        new AdvancedSearchOption(null, 'warehouseIn.UUID', null, AdvancedSearchConsts.OPERATOR_IS_NULL.code).formatObj2Json(),
        new AdvancedSearchOption(null, 'job.WAREHOUSE_NO', null, AdvancedSearchConsts.OPERATOR_IS_NOT_NULL.code).formatObj2Json(),
        new AdvancedSearchOption('FIELD_DATE_RANGE', 'warehouseInfo.ARRIVE_DATE', null, AdvancedSearchConsts.OPERATOR_IS_NOT_NULL.code).formatObj2Json(),
        new AdvancedSearchOption(
          null,
          'warehouseInfo.ARRIVE_DATE',
          `type=date,start=${this.filter.arriveDateStart} 00:00:00,end=${this.filter.arriveDateEnd} 23:59:59`,
          AdvancedSearchConsts.OPERATOR_RANGE.code
        ).formatObj2Json()
      ]
      if (this.filter.warehouseNo.trim()) {
        conditions.push(new AdvancedSearchOption(null, 'job.WAREHOUSE_NO', this.filter.warehouseNo, AdvancedSearchConsts.OPERATOR_LIKE.code).formatObj2Json())
      }
      if (this.filter.conditions && this.filter.conditions.length > 0) {
        conditions = [...conditions, ...this.filter.conditions]
      }
      this.loading = true
      await complexQuerySeJobs({
        conditions,
        branchId: this.$store.getters.currentOfficeId,
        useAdmin: true,
        pageNum: 1,
        pageSize: 1000
      }).then(res => {
        this.rowData = res.data.list
        if (operator !== 'timer') {
          this.resetTimer()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    inWarehouseHandler() {
      if (this.selectedNode) {
        this.tabForm.job = this.selectedNode.data
        this.view = 'detail'
        this.addHandle()
      }
    },
    addHandle() {
      const job = this.tabForm.job
      const rowData = this.$refs.warehousingWorkspace.rowData
      this.$refs.warehousingWorkspace.onShow('add', rowData, { uuid: '', job: job })
    },
    resetTimer() {
      LocalStorageUtils.setConfiguration('SEA_STAY_WAREHOUSING_AUTO_REFRESH', this.autoRefresh)
      this.closeTimer()
      if (this.autoRefresh) {
        this.timerId = setInterval(() => {
          if (this.view === 'list') {
            this.queryJobs('timer')
          }
        }, 5 * 60 * 1000)
      }
    },
    closeTimer() {
      if (this.timerId) {
        clearInterval(this.timerId)
        this.timerId = 0
      }
    },
    refreshHandle() {
      this.backToList(true)
    },
    backToList(isRefresh) {
      this.view = 'list'
      if (isRefresh) {
        this.queryJobs()
      }
    },
    // 打印
    onPrintHandler() {
      const params = {}
      const jobKeys = this.rowData.map(item => item.uuid)
      if (jobKeys.length === 0) {
        return
      }
      params.JOB_UUID = jobKeys
      params.category = 'WAREHOUSE'
      params.USER_ID = this.$store.getters.userInfo.userId
      this.templateSelectorDialog.category = 'WAREHOUSE'
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
    }
  }
}
</script>

<style scoped lang="scss">
.input-label {
  display: inline-block;
  padding: 0 5px;
  color: #666666;
}
#app .app-main-content .grid-view .main-content ::v-deep {
  .grid-wrapper {
    .ag-header-group-cell-no-group {
      display: none;
    }
    .ag-header-group-cell-label {
      justify-content: center;
    }
    .ag-theme-balham {
      .ag-row-hover {
        background: #9bddff !important;
      }
    }
  }
}
</style>
